import { useTranslations } from '@vocab/react';
import { Box, Text, TextLink } from 'braid-design-system';

import translations from './.vocab';

import * as styles from './ScreenReaderSkipLink.css';

export const ScreenReaderSkipLink = () => {
  const { t } = useTranslations(translations);

  return (
    <Box className={styles.screenReaderSkipLink}>
      <Text>
        <TextLink href="#start-of-content">{t('Skip to content')}</TextLink>
      </Text>
    </Box>
  );
};
